export default __webpack_public_path__ + "static/media/Cera Pro Regular.8f68a75d.otf";